import React from 'react';
import Flex from 'components/common/Flex';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const IntestazioneProfiloAzienda = () => {

  const aziendaNome = useSelector((state) => state.questCorrente.aziendaNome);
  
  if (typeof(aziendaNome) != 'undefined' && aziendaNome != null)
    {
        return (
            <Card className="bg-100 shadow-none border mb-3" >
              <Card.Body className="py-0">
                <Row className="g-0 justify-content-between">
                  <Col sm="12">
                    <Flex  style={{margin:"1.5%"}}>
                        <h4 className="text-primary center">{aziendaNome}</h4>
                    </Flex>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
        );
    } 
};

export default IntestazioneProfiloAzienda;